import React from "react";
import logo from '../../../assets/images/logo-riverside.png';
import logoQLP from '../../../assets/images/Logo quoc Loc Phat-04.png';
import LanguageSwitcher from "../common/LanguageSwitcher";
import './UnNavHeader.less';
import { useTranslation } from "react-i18next";

const UnNavHeader = ({ glassTheme = 'default', ...props }) => {
    const { t } = useTranslation();
    return (
        <header id="header" className="animate__animated animate__fadeIn">
            <div className="container unnav_header">
                <div className="header">
                    <div className="logo">
                        <div className="navbar-brand">
                            <img className="logo_img" src={logoQLP} alt="logo" />
                            <div className="splash_line" />
                            <img className="logo_img" src={logo} alt="logo" />
                        </div>
                    </div>
                    <div>
                        <h2 className="header-title">
                            {t('header.select')}  {t('header.parking')}
                        </h2>
                    </div>
                    {LanguageSwitcher()}
                </div>
            </div>
        </header>
    );
};

export default UnNavHeader;